import { i18n } from '@/locales';
const lc = 'views.share_management.';
const hubSharesListTableHeader = [
    {
        title: i18n.t('common.status'),
        align: 'center',
        sortable: false,
        value: 'useYn',
        width: 50,
    },
    {
        title: i18n.t(`${lc}agency_distributor_name`),
        sortable: false,
        align: 'center',
        value: 'distributorName',
        width: 150,
    },
    {
        title: i18n.t(`${lc}agency_hub_name`),
        sortable: true,
        align: 'center',
        value: 'hubName',
        width: 200,
    },
    {
        title: i18n.t(`${lc}share_delay_second`),
        align: 'center',
        sortable: false,
        value: 'shareDelaySecond',
        width: 84,
    },
    {
        title: i18n.t(`${lc}hub_fee_rate`),
        align: 'center',
        sortable: false,
        value: 'feeRate',
        width: 130,
    },
    {
        title: i18n.t(`${lc}worker_fee_rate`),
        align: 'center',
        sortable: false,
        value: 'workerFeeRate',
        width: 130,
    },
    {
        title: i18n.t(`${lc}store_fee_rate`),
        align: 'center',
        sortable: false,
        value: 'storeFeeRate',
        width: 120,
    },
    {
        title: i18n.t(`${lc}store_management_fee_rate`),
        align: 'center',
        sortable: false,
        value: 'storeManagementFeeRate',
        width: 150,
    },
    {
        title: i18n.t(`${lc}is_displayed_on_order`),
        sortable: false,
        value: 'isDisplayedOnOrder',
        width: 108,
    },
    {
        title: i18n.t(`${lc}share_config`),
        sortable: false,
        value: 'isSetup',
        width: 80,
    },
];
// 리스트 페이지 발주 허브 공유 상점
const shareStoreListTableHeader = [
    {
        title: i18n.t(`${lc}share_store_name`),
        sortable: true,
        align: 'center',
        value: 'storeName',
    },
    {
        title: i18n.t(`${lc}share_store_id`),
        sortable: false,
        align: 'center',
        value: 'storeId',
        width: 90,
    },
];
// 상세 페이지 허브 리스트 테이블 헤더
const shareInfoConfigStoreListTableHeader = [
    {
        title: i18n.t(`${lc}share_store_name`),
        sortable: true,
        value: 'storeName',
        width: 355,
    },
    {
        title: i18n.t(`${lc}share_store_id`),
        sortable: false,
        value: 'storeId',
        width: 94,
    },
];
export { hubSharesListTableHeader, shareStoreListTableHeader, shareInfoConfigStoreListTableHeader, };
